import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import {integer} from "vee-validate/dist/rules.esm";
import AutocompleteObject from "../Shared/AutocompleteObject";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            filter: '',
            internalCode: '',
            myUsername: '',
            debtor: false,
            showFilters: false,
            showSort: false,
            showInventory: false,
            sorts: [LocService.t('label_sort_by_date'), LocService.t('label_sort_by_abs')],
            role: '',
            onlyExpireUsers: false,
            namesForPartner: LocService.t('label_name_for_partner'),
            articles: [],
            types: [],
            fromDate : null,
            toDate: null,
            fromInventoryDate: null,
            toInventoryDate: null,
            allCategories: [],
            categories: [],
            selectedSubCategories: [],
            visibleCategory: true,
            visibleSubCategory: true,
            newSelectedCategory: '',
            newSelectedSubCategory: '',
            articleIsNewFilter: 'ALL',
            kpPostedFilter: 'ALL',
            addInfoMemorySuggestions: ['16', '32', '64', '128', '256', '512', '1024'],
            addInfoMemoryFilter: '',
            ramMemorySuggestions: ['2', '3', '4', '6', '8', '12', '16', '24', '32'],
            ramMemoryFilter: '',
            colorFilter: '',
            colorSuggestions: [],
            sort: 'date',
            selectedSort: LocService.t('label_sort_by_date'),
            showImagePreview: false,
            imageToPreview: "",
            imageToPreviewUserId: 0,
            useProfilePictures: false,
            loyaltyProgramsEnabled: false,
            loyaltyPrograms: null,
            loyaltyProgramsList: [],
            maxLoyaltyProgram: 0,
            editArticleId: null,
            editArticleQuantity: null,
            articleChangeProfit: null,
            statuses: [
                {
                    id : 1,
                    state: "ALL",
                    name: LocService.t('label_article_all')
                },
                {
                    id : 2,
                    state: "FOR_APPROVE",
                    name: LocService.t('label_article_for_approve')
                },
                {
                    id : 3,
                    state: "ACTIVE",
                    name: LocService.t('label_article_active')
                },
                {
                    id : 4,
                    state: "SERVICE",
                    name: LocService.t('label_article_service')
                },
                {
                    id : 6,
                    state: "SENT_BY_POST",
                    name: LocService.t('label_article_sent_by_post')
                },
                {
                    id : 5,
                    state: "SOLD",
                    name: LocService.t('label_article_sold')
                },
                {
                    id : 7,
                    state: "ARCHIVED",
                    name: LocService.t('label_article_archived')
                },
            ],
            selectedStatus: {
                id : 1,
                state: "ALL",
                name: LocService.t('label_article_all')
            },
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            },
            totalPurchasePrice: 0,
        }
    },
    computed: {
        filteredUsers() {
            return this.articles;
            // if(this.internalCode.length === 0){
            //     return this.articles;
            // }

            // return this.articles.filter(item => {
            //     console.log("Item: " + String(item.id).padStart(6, '0'))
            //     return String(item.id).padStart(6, '0').toLowerCase().indexOf(this.internalCode.toLowerCase()) > -1
            // })

            //     return (item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
            //         // item.surname.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         // item.username.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         // item.email.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         // item.phone.toLowerCase().indexOf(this.filter.toLowerCase()) > -1) &&
            //
            //
            // })
        }
    },
    components: { AutocompleteObject },
    methods: {
        load: load,
        formatDate: formatDate,
        addArticle: addArticle,
        showStatuses: showStatuses,
        getStyleName: getStyleName,
        clearFilters: clearFilters,
        approveArticle: approveArticle,
        getWaitingForApprove: getWaitingForApprove,
        getChipClass: getChipClass,
        deleteCategory: deleteCategory,
        deleteSubCategory: deleteSubCategory,
        isSelected: isSelected,
        deleteUser: deleteUser,
        getChipClassSort: getChipClassSort,
        isSelectedSort: isSelectedSort,
        editArticle: editArticle,
        stockNumberShow: stockNumberShow,
        getApproveds: getApproveds,
        onSelectedSort: onSelectedSort,
        addToStock: addToStock,
        removeFromStock: removeFromStock,
        fixEmptyNull: fixEmptyNull,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        deleteArticle: deleteArticle,
        recoveryArticle: recoveryArticle,
        openImage: openImage,
        getTrainingTypes: getTrainingTypes,
        changeArticleProfit: changeArticleProfit,
        changeArticleInventory: changeArticleInventory,
        showMainCategory: showMainCategory,
        showSubCategory: showSubCategory,
        clearInventoryFilters: clearInventoryFilters,
        updateColorSuggestionsByCategory: updateColorSuggestionsByCategory,
        getKpStatusClass: getKpStatusClass,
        shouldShowKpStatus: shouldShowKpStatus,
        getKpAdAgeDays: getKpAdAgeDays,
        shouldShowKpAdAge: shouldShowKpAdAge,
        loadCategories: loadCategories,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        }
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowImage', () => {
            _self.showImagePreview = false;
        });

        this.$topnavbar.$on('closeSellBuyArticle', () => {
            _self.editArticleId = null;
            _self.editArticleQuantity = null;
        });

        this.$topnavbar.$on('successSellBuyArticle', (data) => {
            _self.editArticleId = null;
            _self.editArticleQuantity = null;
            swal(
                LocService.t('label_success'),
                LocService.t('label_success') +' '+ data,
                'success'
            ).then((result) => {
                _self.load();
            });
        });

        this.$topnavbar.$on('closeChangeProfit', () => {
            _self.articleChangeProfit = null;
        });

        this.$topnavbar.$on('successChangeProfit', () => {
            _self.articleChangeProfit = null;
            _self.load();
        });
    },
    beforeMount() {
        if( session.getAccessToken() == null || session.getAccessToken() === ''){
            this.$router.push('/login');
            return;
        }
        this.role = session.getRole();
        this.myUsername = session.getUsername();
        // if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
        //     this.$router.push(CONFIG_COMPANY.HOME);
        //     return;
        // }
        this.useProfilePictures = session.getConfig().useProfilePictures == null ? true : session.getConfig().useProfilePictures;
        this.loyaltyProgramsEnabled = session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0;
        this.loyaltyPrograms = session.getConfig().loyaltyPrograms;
        if(session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0){
            let temp = this.loyaltyPrograms.split(";")
            this.loyaltyProgramsList = [];
            temp.forEach(t => {
                this.loyaltyProgramsList.push(parseInt(t));
            })
            this.maxLoyaltyProgram = Math.max(...this.loyaltyProgramsList);
        }
        const cachedCategories = session.getCategories();
        if(cachedCategories != null){
            if (Array.isArray(cachedCategories) && cachedCategories.length > 0) {
                this.allCategories = cachedCategories;
                this.categories = this.allCategories.filter(e => e.parentCategory == null).map(m => m.name);
            } else {
                this.loadCategories();
            }
        }else{
            this.loadCategories();
        }

        this.load()
        this.getTrainingTypes()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load();
            }
        },
        'internalCode': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load();
            }
        },
        'debtor': function (newVal) {
            this.load();
        },
        'onlyExpireUsers': function (newVal) {

        },

        selectedStatus: function (val, old){
           this.load();
        },
        showFilters: function (val, old){
          if(val === false){
              this.clearFilters()
              this.load();
          }else{
              // this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
              // this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
          }
        },
        showInventory: function (val, old){
            if(val === false){
                this.clearInventoryFilters()
                this.load();
            }else{
                // this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
                // this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
            }
        },
        newSelectedCategory: function (val, old){
            this.visibleCategory = !hasTextValue(val)
            if(hasTextValue(val)){
                this.selectedSubCategories = this.allCategories.filter(e => e.parentCategory === val).map(m => m.name);
                this.updateColorSuggestionsByCategory();
            }else{
                this.selectedSubCategories = [];
                this.newSelectedSubCategory = null;
                this.visibleSubCategory = true;
                this.colorSuggestions = [];
            }
        },

        newSelectedSubCategory: function (val, old){
            this.visibleSubCategory = !hasTextValue(val)
        }
    }
}

function hasTextValue(value) {
    return value != null && String(value).trim().length > 0;
}

function parseDateValue(rawValue) {
    if (!hasTextValue(rawValue)) return null;

    if (rawValue instanceof Date) {
        return Number.isNaN(rawValue.getTime()) ? null : rawValue;
    }

    if (typeof rawValue === 'number') {
        const millis = rawValue > 9999999999 ? rawValue : rawValue * 1000;
        const d = new Date(millis);
        return Number.isNaN(d.getTime()) ? null : d;
    }

    const raw = String(rawValue).trim();
    if (/^\d+$/.test(raw)) {
        const numeric = Number(raw);
        if (Number.isNaN(numeric)) return null;
        const millis = numeric > 9999999999 ? numeric : numeric * 1000;
        const d = new Date(millis);
        return Number.isNaN(d.getTime()) ? null : d;
    }

    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) return parsed;

    const m = raw.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (m) {
        const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
        return Number.isNaN(d.getTime()) ? null : d;
    }

    return null;
}

function getKpAdAgeDays(item) {
    if (item == null) return null;
    const parsed = parseDateValue(item.kpPostDate);
    if (parsed == null) return null;

    const today = new Date();
    const startToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startDate = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    const diffMs = startToday.getTime() - startDate.getTime();
    return Math.max(0, Math.floor(diffMs / 86400000));
}

function shouldShowKpAdAge(item) {
    return getKpAdAgeDays(item) != null;
}

function hasKpId(item) {
    if (item == null) return false;
    const kpId = item.kpId != null ? item.kpId : item.kpAdId;
    if (kpId == null) return false;
    return ('' + kpId).trim().length > 0;
}

function isKpParked(item) {
    return item != null && item.kpPark === true;
}

function shouldShowKpStatus(item) {
    return isKpParked(item) || hasKpId(item);
}

function getKpStatusClass(item) {
    if (!shouldShowKpStatus(item)) {
        return '';
    }
    if (isKpParked(item)) {
        return 'article-kp-badge--parked';
    }
    return 'article-kp-badge--linked';
}

function showMainCategory(item){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_show_all')  + ": " + _self.fixEmptyNull(item.mainCategory),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.newSelectedCategory = _self.fixEmptyNull(item.mainCategory)
        _self.showFilters = true;
        _self.load()
    });
}

function showSubCategory(item){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_show_all')  + ": " + _self.fixEmptyNull(item.mainCategory) + " " + _self.fixEmptyNull(item.subCategory),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.newSelectedCategory = _self.fixEmptyNull(item.mainCategory)
        _self.newSelectedSubCategory = _self.fixEmptyNull(item.subCategory)
        _self.showFilters = true;
        _self.load()
    });

}

function changeArticleProfit(article){
    this.articleChangeProfit = article
}

function changeArticleInventory(item){
    let _self = this;
    let message = item.stockNumber === 0 ? LocService.t('label_are_you_sure_to_update_inventory_not_in_stock') : LocService.t('label_are_you_sure_to_update_inventory')
    swal({
        title: LocService.t('label_are_you_sure'),
        text: message + ": "  + " #"+ String(item.id).padStart(6, '0') + " - " + _self.fixEmptyNull(item.mainCategory) + " " + _self.fixEmptyNull(item.subCategory),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            id : item.id,
        }
        AdminApiService.updateArticleInventory(model)
            .then((response) => {
                swal( LocService.t('label_success'),  LocService.t('label_article_inventory_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                console.log(error)
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}


function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId;
    this.showImagePreview = true;
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
}

function load() {
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        sort: _self.sort,
        internalCode: _self.internalCode,
        mainCategory: _self.newSelectedCategory,
        subCategory: _self.newSelectedSubCategory,
        state: _self.selectedStatus.state,
        fromDate : _self.fromDate != null ? _self.$moment(_self.fromDate).format('DD-MM-YYYY') : null,
        toDate : _self.toDate != null ? _self.$moment(_self.toDate).format('DD-MM-YYYY'): null,
        fromInventoryDate : _self.fromInventoryDate != null ? _self.$moment(_self.fromInventoryDate).format('DD-MM-YYYY') : null,
        toInventoryDate : _self.toInventoryDate != null ? _self.$moment(_self.toInventoryDate).format('DD-MM-YYYY'): null,
    }

    if (_self.articleIsNewFilter === 'NEW') {
        request.isNewArticle = true;
    } else if (_self.articleIsNewFilter === 'USED') {
        request.isNewArticle = false;
    }

    if (_self.kpPostedFilter === 'POSTED') {
        request.kpPosted = true;
    } else if (_self.kpPostedFilter === 'NOT_POSTED') {
        request.kpPosted = false;
    }

    if (hasTextValue(_self.addInfoMemoryFilter)) {
        request.addInfoMemory = _self.addInfoMemoryFilter.trim();
    }
    if (hasTextValue(_self.ramMemoryFilter)) {
        request.ramMemory = _self.ramMemoryFilter.trim();
    }
    if (hasTextValue(_self.colorFilter)) {
        request.color = _self.colorFilter.trim();
    }

    AdminApiService.getArticles(request)
        .then((response) => {
            _self.articles = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
            _self.totalPurchasePrice = response.data.totalPurchasePrice != null ? response.data.totalPurchasePrice : 0;
            swal.close();
        })
        .catch((error) => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function loadCategories() {
    let _self = this;
    AdminApiService.getArticleCategories()
        .then((response) => {
            _self.allCategories = Array.isArray(response.data) ? response.data : [];
            session.saveArticleCategories(_self.allCategories);
            _self.categories = _self.allCategories.filter(e => e.parentCategory == null).map(m => m.name);
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



function deleteUser(user) {
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_delete_user')  + ": " + user.name,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteUser(user.id)
            .then((response) => {
                swal( LocService.t('label_success'), LocService.t('label_user_deleted_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });


}

function addArticle() {
    this.$router.push('/add-article')
}


function editArticle(id) {
    this.$router.push('/add-article?id='+id)
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function deleteArticle(item) {
    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text:  LocService.t('label_are_you_sure_to_remove_article') + ": " + item.mainCategory + " - " + item.subCategory +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteArticle(item.id)
            .then((response) => {
                swal( LocService.t('label_success'),  LocService.t('label_article_removed_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                console.log(error)
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });

}

function recoveryArticle(item) {
    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text:  LocService.t('label_are_you_sure_to_recovery_article') + ": " + item.mainCategory + " - " + item.subCategory +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.recoveryArticle(item.id)
            .then((response) => {
                swal( LocService.t('label_success'),  LocService.t('label_article_recovered_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                console.log(error)
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });

}

function approveArticle(item){
    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text:  LocService.t('label_are_you_sure_to_approve_article') + ": " + item.mainCategory + " - " + item.subCategory + "-" + item.code +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        let model =  {
            id: item.id
        }
        AdminApiService.approveArticleStock(model)
            .then((response) => {
                swal( LocService.t('label_success'),  LocService.t('label_article_approved_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function showStatuses(item){
    if(item.states == null) return;
    if(item.states.length === 0) return;
    let sub = item.states.split(";").filter(e=> e.length > 0)
    var newList = ""
    var index = 1;
    sub.forEach(e => {
        newList += index +". " + e +"<br>";
        index++;
    })
    swal("Radnje nad artiklom", newList, 'success')
}


function stockNumberShow(item) {
    let _self = this
    swal({
        title: LocService.t("label_a_stock_number_set"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" type="number" placeholder="'+ LocService.t("label_a_stock_number_set") +'" class="input" style="width: 50%; border-radius: 10px; color: white;" value="'+ item.stockNumber +'" />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var trainingsNumber = document.getElementById('swal-input').value
        var num = parseInt(trainingsNumber)
        if(num === item.stockNumber){
            swal.close();
            return;
        }

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        let model = {
            id: item.id,
            stockNumber: num,
        }

        AdminApiService.updateArticleStock(model)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });

}

function removeFromStock(item){
    this.editArticleId = item;
    this.editArticleQuantity = 0;
    return;
    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text:  LocService.t('label_are_you_sure_to_remove_to_stock') + ": " + item.mainCategory + " - " + item.subCategory + "-" + item.code +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {

        let model = {
            id: item.id,
            stockNumber: 0,
        }

        AdminApiService.updateArticleStock(model)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function addToStock(item){
    this.editArticleId = item;
    this.editArticleQuantity = 1;
    return;

    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text:  LocService.t('label_are_you_sure_to_add_to_stock') + ": " + item.mainCategory + " - " + item.subCategory + "-" + item.code +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {

        let model = {
            id: item.id,
            stockNumber: 1,
        }

        AdminApiService.updateArticleStock(model)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function getStyleName(item){
    if(item.stockNumber <= 0) return 'color: red;'
    return 'color: white;'
}

function fixEmptyNull(data){
    if(data == null || data.length <= 0) return "/"
    return data;
}

function deleteCategory(){
    this.newSelectedCategory = null;
    this.newSelectedSubCategory = null;
    this.visibleCategory = true;
    this.visibleSubCategory = true;
    this.$topnavbar.$emit('newItemSetToAutocompletearticlesCategoryFilter', '');
    this.$topnavbar.$emit('newItemSetToAutocompletearticlesSubCategoryFilter', '');
}

function deleteSubCategory(){
    this.newSelectedSubCategory = null;
    this.visibleSubCategory = true;
    this.$topnavbar.$emit('newItemSetToAutocompletearticlesSubCategoryFilter', '');
}

function clearFilters(){
    this.newSelectedCategory = null;
    this.newSelectedSubCategory = null;
    this.fromDate = null;
    this.toDate= null;
    this.articleIsNewFilter = 'ALL';
    this.kpPostedFilter = 'ALL';
    this.addInfoMemoryFilter = '';
    this.ramMemoryFilter = '';
    this.colorFilter = '';
    this.colorSuggestions = [];
    this.$topnavbar.$emit('newItemSetToAutocompletearticlesCategoryFilter', '');
    this.$topnavbar.$emit('newItemSetToAutocompletearticlesSubCategoryFilter', '');
}

function clearInventoryFilters(){
    this.fromInventoryDate = null;
    this.toInventoryDate= null;
}

function updateColorSuggestionsByCategory() {
    var selectedMainCategory = hasTextValue(this.newSelectedCategory) ? String(this.newSelectedCategory).trim() : null;
    var found = null;
    if (selectedMainCategory != null) {
        found = this.allCategories.find(function (c) {
            if (c == null) return false;
            var name = c.name != null ? String(c.name).trim() : '';
            return name === selectedMainCategory;
        });
    }

    if (found == null || found.color == null || String(found.color).trim().length === 0) {
        this.colorSuggestions = [];
        return;
    }

    var unique = {};
    var parsed = String(found.color)
        .split(';')
        .map(function (x) { return x != null ? String(x).trim() : ''; })
        .filter(function (x) { return x.length > 0; })
        .filter(function (x) {
            var key = x.toLowerCase();
            if (unique[key]) return false;
            unique[key] = true;
            return true;
        });

    this.colorSuggestions = parsed;
}

function getChipClass(item){
    if(this.selectedStatus.id === item.id){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item){
    return this.selectedStatus.id === item.id
}

function getChipClassSort(item){
    if(this.selectedSort === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedSort(item){
    return this.selectedSort === item
}

function getApproveds(item){
    return item.approvedBy.split(";").filter(e=> e.length > 0)
}

function getWaitingForApprove(item){
    return item.waitingApproval.split(";").filter(e=> e.length > 0)
}

function onSelectedSort(item){
    this.selectedSort = item;
    if(this.selectedSort === LocService.t('label_sort_by_abs')){
        this.sort = 'abc'
    }else{
        this.sort = 'date'
    }
    this.load();
}



// WEBPACK FOOTER //
// ./src/components/Article/Articles.js